/* eslint-disable no-return-await */
/* eslint-disable consistent-return */
/* eslint-disable no-plusplus */
/* eslint-disable no-shadow */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable func-names */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable no-dupe-keys */
/* eslint-disable no-use-before-define */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable no-unused-vars */
import React, { useEffect, useMemo, useState } from 'react'
import Link from 'next/link'
import { useAuth0 } from '@auth0/auth0-react'
import { DateTime } from 'luxon'
import {
  Button,
  Card,
  Grid,
  Input,
  Modal,
  Select,
  Spacer,
  Spinner,
  Text,
  Textarea,
  useModal,
  useToasts,
  useMediaQuery,
} from '@geist-ui/react'
import { useForm } from 'react-hook-form'
import axios from 'axios'
import { getToday, phoneTransform, toTitleCase } from 'utils'
import InputMask from 'react-input-mask'
import { useToken, useProfile, useClaims } from 'hooks'

import ReEnroll from '../ReEnroll'
import ClaimEnrollmentPrompt from '../ClaimEnrollmentPrompt'

const buildEnrollmentKey = (record) => {
  if (!record) {
    return ''
  }
  const accountId = (record.account_id || '').toString().trim()
  const address = (record.account_address || record.display_address || '')
    .toString()
    .trim()
  return `${accountId}::${address.toLowerCase()}`
}

const formatEnrollmentLabel = (record) => {
  if (!record) {
    return 'Unknown enrollment'
  }
  const address =
    record.display_address || record.account_address || 'Unknown address'
  const account = record.account_id ? `Account ${record.account_id}` : ''
  return account ? `${address} — ${account}` : address
}

export default function ClaimForm() {
  const {
    profile: primaryEnrollment,
    linkedEnrollments,
    unclaimed,
    claimedByOther,
    inactive,
    attemptInfo,
    isLoading: profileLoading,
    isLinking,
    error: profileError,
    claimEnrollment,
  } = useProfile()

  const today = getToday()
  const [toast, setToast] = useToasts()
  const { visible, setVisible, bindings } = useModal()
  const [isLoading, setIsLoading] = useState(false)

  const [accountAge, setAccountAge] = useState()
  const [unlockDate, setUnlockDate] = useState()
  const [image, setImage] = useState()
  const [fileTooLarge, setFileTooLarge] = useState(false)

  const [activeEnrollmentKey, setActiveEnrollmentKey] = useState(() =>
    buildEnrollmentKey(primaryEnrollment)
  )

  const { user } = useAuth0()
  const { headers } = useToken()

  const isMobile = useMediaQuery('xs')

  useEffect(() => {
    setActiveEnrollmentKey(buildEnrollmentKey(primaryEnrollment))
  }, [primaryEnrollment])

  const profile = useMemo(() => {
    if (!activeEnrollmentKey) {
      return primaryEnrollment
    }
    const match = linkedEnrollments?.find(
      (record) => buildEnrollmentKey(record) === activeEnrollmentKey
    )
    return match || primaryEnrollment
  }, [activeEnrollmentKey, linkedEnrollments, primaryEnrollment])

  const {
    claims,
    isLoading: claimsLoading,
    error: claimsError,
  } = useClaims(profile?.account_id)

  const {
    register,
    handleSubmit,
    setValue,
    reset,
    formState: { errors, isSubmitSuccessful },
  } = useForm()

  const validPhone = parseInt(profile?.phone_number)

  useEffect(() => {
    if (!profile) {
      setAccountAge(undefined)
      setUnlockDate(undefined)
      return
    }

    setValue('customer_name', profile.person_entity_name || '')
    setValue('account_id', profile.account_id || '')
    setValue('city', profile.city || '')
    setValue('state', profile.state || '')
    setValue('zip_code', profile.account_zip || '')
    setValue(
      'service_address',
      profile.account_address || profile.display_address || ''
    )
    setValue('date_of_claim', today)
    setValue('email', user?.email || '')

    if (validPhone) {
      setValue('phone_number', phoneTransform(profile.phone_number))
    }

    if (profile.opt_in_date) {
      const startDate = new Date(profile.opt_in_date)
      if (!Number.isNaN(startDate.getTime())) {
        const now = new Date()
        const timeDifferential = now.getTime() - startDate.getTime()
        const dayDifferential = timeDifferential / (1000 * 3600 * 24)
        setAccountAge(dayDifferential)

        const reformattedDate = DateTime.fromMillis(startDate.getTime())
        const thirtyDayMark = reformattedDate.plus({ days: 30 })
        setUnlockDate(thirtyDayMark.toLocaleString(DateTime.DATE_FULL))
        return
      }
    }

    setAccountAge(undefined)
    setUnlockDate(undefined)
  }, [profile, setValue, today, user?.email, validPhone])

  if (profileLoading || claimsLoading) {
    return (
      <Grid.Container
        justify="center"
        style={{ marginTop: '6rem', textAlign: 'center' }}
      >
        <Spinner />
      </Grid.Container>
    )
  }

  if (profileError || claimsError) {
    return (
      <Card
        shadow
        style={{
          marginTop: '6rem',
          maxWidth: '540px',
          marginLeft: 'auto',
          marginRight: 'auto',
        }}
      >
        <Text h3>We hit a snag</Text>
        <Text p>
          We couldn&apos;t load your enrollment details right now. Please try
          refreshing the page. If the issue persists, contact WaterPro support
          at <strong>888-977-7481</strong> or{' '}
          <strong>info@waterproplan.com</strong>.
        </Text>
      </Card>
    )
  }

  if (!profile) {
    if (unclaimed.length > 0) {
      return (
        <ClaimEnrollmentPrompt
          unclaimed={unclaimed}
          claimedByOther={claimedByOther}
          onClaim={claimEnrollment}
          isLinking={isLinking}
          attemptInfo={attemptInfo}
        />
      )
    }

    if (inactive.length > 0) {
      return (
        <Grid.Container
          justify="center"
          alignItems="center"
          height="90vh"
          width="600px"
          style={{ padding: '5rem 3rem', margin: '0 auto' }}
        >
          <Grid
            direction="column"
            justify="center"
            style={{
              padding: '1rem 2rem',
              textAlign: 'center',
            }}
          >
            <Text h2>Your account is not currently active.</Text>
            <Text p>
              Looks like your account was cancelled. If this was a mistake or
              you wish to re-enroll in the WaterPro Water Leak Protection Plan℠,
              tap or click the button below.
            </Text>
            <Spacer h={1} />

            <ReEnroll />
          </Grid>
        </Grid.Container>
      )
    }

    return (
      <Card
        shadow
        style={{
          marginTop: '6rem',
          maxWidth: '540px',
          marginLeft: 'auto',
          marginRight: 'auto',
        }}
      >
        <Text h3>No matching enrollment found</Text>
        <Text p>
          We couldn&apos;t find an active WaterPro enrollment that matches your
          account details. Double-check your information or reach out to support
          at <strong>888-977-7481</strong> or{' '}
          <strong>info@waterproplan.com</strong> for assistance.
        </Text>
      </Card>
    )
  }

  const accountTooYoung = accountAge < 30

  const mostRecentClaimRecord = claims?.[0] || null
  const mostRecentClaimDate = mostRecentClaimRecord
    ? new Date(mostRecentClaimRecord.date_of_claim)
    : null
  const reformattedClaimDate = mostRecentClaimDate
    ? DateTime.fromMillis(mostRecentClaimDate.getTime())
    : null
  const claimUnlockDate = reformattedClaimDate
    ? reformattedClaimDate.plus({ months: 1 })
    : null
  const claimUnlockCondensed = claimUnlockDate
    ? claimUnlockDate.toLocaleString(DateTime.DATE_FULL)
    : null

  const claimTooRecent = claimUnlockDate
    ? DateTime.now() < claimUnlockDate
    : false

  // Callback from a <input type="file" onchange="onChange(event)">
  function readFile(e) {
    const file = e.target.files[0]

    const base64Reader = new FileReader()
    base64Reader.onload = function (e) {
      setImage(e.target.result)
    }
    base64Reader.readAsDataURL(file)
  }

  const fileSizeHandler = (e) => {
    readFile(e)
    const files = Array.from(e.target.files)
    const TEN_MEGABYTES = 10485760

    const totalFileSize = files.reduce(
      (total, currentFile) => total + currentFile.size,
      0
    )

    totalFileSize > TEN_MEGABYTES
      ? !fileTooLarge && setFileTooLarge(true)
      : fileTooLarge && setFileTooLarge(false)
  }

  // returns a pre-filled, disabled input field if user account has phone #, and a fillable, input-masked one if they do not
  function PhoneField({ mask, placeholder, required, disabled, width }) {
    return validPhone ? (
      <Input
        {...register('phone_number')}
        placeholder={placeholder}
        required={required}
        disabled={disabled}
        width={width}
      />
    ) : (
      <InputMask
        {...register('phone_number')}
        mask={mask}
        placeholder={placeholder}
        required={required}
        disabled={disabled}
        width={width}
      >
        {(inputProps) => <Input {...inputProps} />}
      </InputMask>
    )
  }

  const onSubmit = async (data) => {
    setIsLoading(true)

    const file = data.proof_of_repair[0]
    const { type } = file || ''

    const claim = {
      account_id: data.account_id,
      customer_name: data.customer_name,
      email: data.email,
      phone_number: data.phone_number.replace(/\D+/g, ''), // .replace regex removes all characters but number itself
      contact_preference: data.contact_preference,
      service_address: data.service_address,
      city: data.city,
      state: data.state,
      zip_code: data.zip_code,
      date_of_claim: data.date_of_claim,
      date_of_leak: data.date_of_leak,
      leak_type: data.leak_type,
      date_of_repair: data.date_of_repair,
      household_size: data.household_size,
      notes: data.repair_description,
      file_type: type,
    }

    const update = {
      account_id: data.account_id,
      account_address: data.service_address,
      phone_number: data.phone_number.replace(/\D+/g, ''),
    }

    await axios({
      method: 'post',
      url: `${process.env.NEXT_PUBLIC_API_URL}/claim`,
      headers,
      data: claim,
    })
      .then((res) => {
        const url = res.data

        if (url === '') {
          return
        }

        const binary_formatted_image = atob(image.split(',')[1])
        const char_array = []
        for (let i = 0; i < binary_formatted_image.length; i++) {
          char_array.push(binary_formatted_image.charCodeAt(i))
        }
        const image_blob = new Blob([new Uint8Array(char_array)], {
          type: 'image/jpeg',
        })

        axios({
          method: 'put',
          url,
          headers: { 'Content-Type': type },
          data: image_blob,
        }).catch((err) => {
          setIsLoading(false)
          setToast({
            text: 'Claim submitted successfully, but there was an error uploading your proof of repair. Please contact support@waterproplan.com',
            type: 'error',
            delay: 5000,
          })
          return err
        })
        setIsLoading(false)
      })
      .then(() => {
        setTimeout(() => {
          setIsLoading(false)
          setVisible(true)
          setValue('repair_description', '')
          setValue('date_of_leak', '')
          setValue('leak_type', '')
          setValue('date_of_repair', '')
          setValue('household_size', '')
          setValue('notes', '')
          setValue('proof_of_repair', '')
        }, 1000)
      })
      .then(() => {
        !validPhone &&
          axios({
            method: 'put',
            url: `${process.env.NEXT_PUBLIC_API_URL}/enrollment`,
            headers,
            data: update,
          })
      })
      .catch((e) => {
        setIsLoading(false)
        setToast({
          text: 'Error submitting claim. Please try again.',
          type: 'error',
          delay: 5000,
        })
        return e
      })
  }

  return (
    <Grid.Container
      justify="space-around"
      alignItems="start"
      height="100%"
      style={{ padding: '5rem 3rem' }}
    >
      {/* MODAL DISPLAYS ON SUCCESSFUL SUBMISSION OF FORM */}
      <Modal {...bindings}>
        <Modal.Title>Claim successfully submitted!</Modal.Title>
        <Modal.Content>
          <p>
            Thanks for submitting your WaterPro Water Leak Protection Plan℠
            claim. If you have any questions, please contact{' '}
            <a href="mailto:info@waterproplan.com">info@waterproplan.com.</a>
          </p>
        </Modal.Content>
        <Modal.Action passive onClick={() => setVisible(false)}>
          Close
        </Modal.Action>
      </Modal>
      {/* END MODAL */}

      <Grid direction="column" justify="center" xs={24} lg={6}>
        {accountAge < 30 ? (
          <>
            <Text h3 style={{ marginTop: '15px' }}>
              {`Sorry, ${toTitleCase(profile?.first_name)}.`}
            </Text>
            <Text h3 style={{ marginTop: '-15px' }}>
              You'll be able to file your claims 30 days after your account has
              opened.
            </Text>
          </>
        ) : (
          <>
            <Text h3 style={{ marginTop: '15px' }}>
              {`Welcome, ${toTitleCase(profile?.first_name)}.`}
            </Text>
            <Text h3 style={{ marginTop: '-15px' }}>
              File your claim today!
            </Text>
          </>
        )}

        <Text p small>
          The WaterPro℠ Water Leak Protection Plan covers up to $3,000 of excess
          water and wastewater charges from one qualifying leak in a 12-month
          period. To learn more about claim eligibility, view the Program
          Guidelines{' '}
          <a href="https://waterproplan.com/wp-content/uploads/2021/10/WaterPro-Guidelines.pdf)">
            here
          </a>
          . Submit your claim by completing the form. If you have any questions
          or need assistance, please contact WaterPro customer support at{' '}
          <a href="tel:8889777481">888-977-7481</a>.
        </Text>

        {claims?.length > 0 && (
          <>
            <Text h3 style={{ marginTop: '15px' }}>
              Your past claims:
            </Text>
            <ul id="pastClaims">
              {claims?.map((claim) => (
                <li style={{ listStyleType: 'disc' }}>
                  <Link href={`/claims/${claim.claim_id}`}>
                    {claim.date_of_claim}
                  </Link>
                </li>
              ))}
            </ul>
          </>
        )}
      </Grid>

      <Grid xs={24} lg={12} direction="column" justify="end">
        {linkedEnrollments?.length > 1 && (
          <>
            <Card
              shadow
              style={{
                marginBottom: '1.5rem',
                background: '#f8f9fb',
              }}
            >
              <Text h4 style={{ marginBottom: '0.5rem' }}>
                Choose an enrollment
              </Text>
              <Text small style={{ marginBottom: '0.75rem', color: '#666' }}>
                We found multiple WaterPro enrollments linked to your account.
                Select the service address you want to manage right now.
              </Text>
              <Select
                width="100%"
                placeholder="Select an enrollment"
                value={activeEnrollmentKey || undefined}
                onChange={(value) => {
                  const nextValue = Array.isArray(value) ? value[0] : value
                  setActiveEnrollmentKey(
                    nextValue || buildEnrollmentKey(primaryEnrollment)
                  )
                }}
              >
                {linkedEnrollments.map((record) => {
                  const key = buildEnrollmentKey(record)
                  return (
                    <Select.Option key={key} value={key}>
                      {formatEnrollmentLabel(record)}
                    </Select.Option>
                  )
                })}
              </Select>
            </Card>
            <Spacer h={1} />
          </>
        )}

        {unclaimed.length > 0 && (
          <>
            <ClaimEnrollmentPrompt
              variant="inline"
              title="Link another enrollment"
              description="You have other active WaterPro enrollments that haven't been linked yet. Choose an address below to attach it to your profile."
              unclaimed={unclaimed}
              claimedByOther={claimedByOther}
              onClaim={claimEnrollment}
              isLinking={isLinking}
              attemptInfo={attemptInfo}
              showSupportNote={false}
            />
            <Spacer h={1.5} />
          </>
        )}

        {accountTooYoung && (
          <Grid.Container
            style={{
              minHeight: '400px',
              background: '#f4f5f8',
              borderRadius: '1rem',
            }}
            direction="column"
            alignItems="center"
            justify="center"
          >
            <Grid>
              <h3>Claim form will unlock on {unlockDate}</h3>
            </Grid>
          </Grid.Container>
        )}

        {claimTooRecent && (
          <Grid.Container
            style={{
              minHeight: '400px',
              background: '#f4f5f8',
              borderRadius: '1rem',
              padding: '40px',
            }}
            direction="column"
            alignItems="center"
            justify="center"
          >
            <Grid style={{ textAlign: 'center' }}>
              {isMobile ? (
                <h4>You have submitted a claim within the past 30 days</h4>
              ) : (
                <h3>You have submitted a claim within the past 30 days</h3>
              )}

              <p>
                Your ability to file another claim will unlock on{' '}
                {claimUnlockCondensed}. If you need to amend your previous claim
                or have questions call us at 888-977-7481 or email
                info@waterproplan.com
              </p>
            </Grid>
          </Grid.Container>
        )}

        {profile && !accountTooYoung && !claimTooRecent && (
          <form onSubmit={handleSubmit(onSubmit)}>
            <Grid.Container gap={2}>
              <Grid direction="column" xs={12}>
                <Input {...register('customer_name')} disabled width="100%" />
              </Grid>

              <Grid direction="column" xs={12}>
                <Input
                  {...register('account_id')}
                  initialValue="LWC account number"
                  disabled
                  width="100%"
                />
              </Grid>
            </Grid.Container>

            <Spacer h={1} />

            <Grid.Container gap={2}>
              <Grid direction="column" xs={24}>
                <Input
                  {...register('service_address')}
                  initialValue="Service address"
                  disabled
                  width="100%"
                />
              </Grid>
            </Grid.Container>

            <Spacer h={1} />

            <Grid.Container gap={2}>
              <Grid direction="column" xs={12} sm={8}>
                <Input
                  {...register('city')}
                  initialValue="City"
                  disabled
                  width="100%"
                />
              </Grid>
              <Grid direction="column" xs={12} sm={8}>
                <Input
                  {...register('state')}
                  initialValue="State"
                  disabled
                  width="100%"
                />
              </Grid>
              <Grid direction="column" xs={24} sm={8}>
                <Input
                  {...register('zip_code')}
                  initialValue="Zip code"
                  disabled
                  width="100%"
                />
              </Grid>
            </Grid.Container>

            <Spacer h={1} />

            <Grid.Container gap={2}>
              <Grid direction="column" xs={12}>
                <Input {...register('email')} disabled width="100%" />
              </Grid>

              <Grid direction="column" xs={12}>
                <PhoneField
                  mask="(999) 999-9999"
                  placeholder="Phone number"
                  required
                  disabled={validPhone || false}
                  width="100%"
                />
              </Grid>
            </Grid.Container>

            <Spacer h={1} />

            <Grid.Container gap={2}>
              <Grid direction="column" xs={24}>
                <label
                  style={{
                    'font-size': '14px',
                    height: '100%',
                    color: '#444',
                    'margin-bottom': '7px',
                    'margin-top': '10px',
                  }}
                  htmlFor="contact_preference"
                >
                  What is your preferred method of communication regarding your
                  claim?
                </label>
                <div>
                  <div
                    name="contact_preference"
                    width="100%"
                    className="select"
                    style={{
                      display: '-webkit-inline-box',
                      display: '-webkit-inline-flex',
                      display: '-ms-inline-flexbox',
                      display: 'inline-flex',
                      '-webkit-align-items': 'center',
                      '-webkit-box-align': 'center',
                      '-ms-flex-align': 'center',
                      'align-items': 'center',
                      '-webkit-user-select': 'none',
                      '-moz-user-select': 'none',
                      '-ms-user-select': 'none',
                      'user-select': 'none',
                      'white-space': 'nowrap',
                      position: 'relative',
                      cursor: 'pointer',
                      'max-width': '90vw',
                      overflow: 'hidden',
                      '-webkit-transition':
                        'border 150ms ease-in 0s,color 200ms ease-out 0s, box-shadow 200ms ease 0s',
                      transition:
                        'border 150ms ease-in 0s,color 200ms ease-out 0s, box-shadow 200ms ease 0s',
                      border: '1px solid #eaeaea',
                      'border-radius': '5px',
                      'background-color': '#fff',
                      '--select-font-size': 'calc(0.875 * 16px)',
                      '--select-height': 'calc(2.25 * 16px)',
                      'min-width': '11.5em',
                      width: '100%',
                      height: 'var(--select-height)',
                      padding: '0 calc(0.334 * 16px) 0 calc(0.667 * 16px)',
                      margin: '0 0 0 0',
                    }}
                  >
                    <span
                      className="value"
                      style={{
                        display: '-webkit-inline-box',
                        display: '-webkit-inline-flex',
                        display: '-ms-inline-flexbox',
                        display: 'inline-flex',
                        '-webkit-flex': '1',
                        '-ms-flex': '1',
                        flex: '1',
                        height: '100%',
                        '-webkit-align-items': 'center',
                        '-webkit-box-align': 'center',
                        '-ms-flex-align': 'center',
                        'align-items': 'center',
                        'line-height': '1',
                        padding: '0',
                        'margin-right': '1.25em',
                        'font-size': 'var(--select-font-size)',
                        color: '#000',
                        width: 'calc(100% - 1.25em)',
                      }}
                    >
                      <select
                        required
                        id="contact_preference"
                        {...register('contact_preference')}
                        style={{
                          margin: '0.25em 0.625em',
                          padding: 0,
                          'box-shadow': 'none',
                          'font-size': 'calc(0.875 * 16px)',
                          'background-color': 'transparent',
                          border: 'none',
                          color: '#000',
                          outline: 'none',
                          'border-radius': '0',
                          width: '100%',
                          height: '100%',
                          'min-width': '0',
                          '-webkit-appearance': 'none',
                        }}
                      >
                        <option value="" disabled selected hidden>
                          Please choose an option
                        </option>
                        <option value="Text">Text</option>
                        <option value="Email">Email</option>
                        <option value="Phone Call">Phone Call</option>
                      </select>
                    </span>
                  </div>
                </div>
              </Grid>
              <Grid direction="column" xs={12}>
                <Input
                  required
                  htmlType="number"
                  {...register('household_size')}
                  width="100%"
                >
                  Household size
                </Input>
              </Grid>

              <Grid direction="column" xs={12}>
                <label
                  style={{
                    'font-size': '14px',
                    height: '100%',
                    color: '#444',
                    'margin-bottom': '7px',
                  }}
                  htmlFor="leak_type"
                >
                  Type of leak
                </label>
                <div>
                  <div
                    name="leak_type"
                    width="100%"
                    className="select"
                    style={{
                      display: '-webkit-inline-box',
                      display: '-webkit-inline-flex',
                      display: '-ms-inline-flexbox',
                      display: 'inline-flex',
                      '-webkit-align-items': 'center',
                      '-webkit-box-align': 'center',
                      '-ms-flex-align': 'center',
                      'align-items': 'center',
                      '-webkit-user-select': 'none',
                      '-moz-user-select': 'none',
                      '-ms-user-select': 'none',
                      'user-select': 'none',
                      'white-space': 'nowrap',
                      position: 'relative',
                      cursor: 'pointer',
                      'max-width': '90vw',
                      overflow: 'hidden',
                      '-webkit-transition':
                        'border 150ms ease-in 0s,color 200ms ease-out 0s, box-shadow 200ms ease 0s',
                      transition:
                        'border 150ms ease-in 0s,color 200ms ease-out 0s, box-shadow 200ms ease 0s',
                      border: '1px solid #eaeaea',
                      'border-radius': '5px',
                      'background-color': '#fff',
                      '--select-font-size': 'calc(0.875 * 16px)',
                      '--select-height': 'calc(2.25 * 16px)',
                      'min-width': '11.5em',
                      width: '100%',
                      height: 'var(--select-height)',
                      padding: '0 calc(0.334 * 16px) 0 calc(0.667 * 16px)',
                      margin: '0 0 0 0',
                    }}
                  >
                    <span
                      className="value"
                      style={{
                        display: '-webkit-inline-box',
                        display: '-webkit-inline-flex',
                        display: '-ms-inline-flexbox',
                        display: 'inline-flex',
                        '-webkit-flex': '1',
                        '-ms-flex': '1',
                        flex: '1',
                        height: '100%',
                        '-webkit-align-items': 'center',
                        '-webkit-box-align': 'center',
                        '-ms-flex-align': 'center',
                        'align-items': 'center',
                        'line-height': '1',
                        padding: '0',
                        'margin-right': '1.25em',
                        'font-size': 'var(--select-font-size)',
                        color: '#000',
                        width: 'calc(100% - 1.25em)',
                      }}
                    >
                      <select
                        required
                        id="leak_type"
                        {...register('leak_type')}
                        style={{
                          margin: '0.25em 0.625em',
                          padding: 0,
                          'box-shadow': 'none',
                          'font-size': 'calc(0.875 * 16px)',
                          'background-color': 'transparent',
                          border: 'none',
                          color: '#000',
                          outline: 'none',
                          'border-radius': '0',
                          width: '100%',
                          height: '100%',
                          'min-width': '0',
                          '-webkit-appearance': 'none',
                        }}
                      >
                        <option value="" disabled selected hidden>
                          Please choose an option
                        </option>
                        <option value="Inside the home">Inside the home</option>
                        <option value="Under the home">Under the home</option>
                        <option value="Primary exterior water service line to the home">
                          Primary exterior water service line to the home
                        </option>
                        <option value="Exterior water line to a non-residential structure">
                          Exterior water line to a non-residential structure
                        </option>
                        <option value="Plumbing inside or attached to a non-residential structure">
                          Plumbing inside or attached to a non-residential
                          structure
                        </option>
                        <option value="Water line or faucet used as a sprinkler system">
                          Water line or faucet used as a sprinkler system
                        </option>
                        <option value="Detached faucet">Detached faucet</option>
                        <option value="Other">Other</option>
                      </select>
                    </span>
                  </div>
                </div>
              </Grid>
              <Grid direction="column" xs={24} sm={12}>
                <Input
                  required
                  htmlType="date"
                  {...register('date_of_leak')}
                  placeholder="mm/dd/yyyy"
                  width="100%"
                >
                  Date of leak
                </Input>
              </Grid>

              {isMobile && <Spacer h={1} />}
              <Grid direction="column" xs={24} sm={12}>
                <Input
                  required
                  htmlType="date"
                  {...register('date_of_repair')}
                  placeholder="mm/dd/yyyy"
                  width="100%"
                >
                  Date of repair
                </Input>
              </Grid>
            </Grid.Container>

            <Spacer h={3} />

            <Grid.Container gap={2}>
              <Grid direction="column" xs={24}>
                <Textarea
                  required
                  {...register('repair_description')}
                  placeholder="Give a brief description of the repair"
                  width="100%"
                />
              </Grid>
            </Grid.Container>

            <Spacer h={1} />

            <Grid.Container gap={2} alignItems="center">
              <Grid direction="column">
                <Input {...register('date_of_claim')} disabled width="100%">
                  Today's Date
                </Input>
              </Grid>
              <Grid direction="column">
                <label>
                  <Text
                    p
                    style={{
                      margin: '0 0 .5rem',
                      fontSize: '.9rem',
                      opacity: '0.75',
                    }}
                  >
                    Upload proof of repair{' '}
                    <small style={{ opacity: '.6' }}>
                      .jpg, .png, .pdf | 10MB max
                    </small>
                  </Text>
                  <input
                    {...register('proof_of_repair')}
                    type="file"
                    accept=".pdf,.jpeg,.png"
                    onChange={fileSizeHandler}
                  />
                  {fileTooLarge && (
                    <p
                      style={{
                        fontSize: '14px',
                        color: 'red',
                      }}
                    >
                      Total file size cannot exceed 10MB
                    </p>
                  )}
                </label>
              </Grid>
            </Grid.Container>

            <Spacer h={2} />

            <Grid.Container gap={2} alignItems="center">
              <Grid mx="10px" justify="center">
                <input
                  required
                  id="acknowledgement"
                  aria-describedby="acknowledgement"
                  name="acknowledgement"
                  type="checkbox"
                />
                <label htmlFor="acknowledgement" style={{ marginLeft: '10px' }}>
                  Acknowledgement of legitimate claim submission.
                </label>
              </Grid>
            </Grid.Container>

            <Spacer h={1} />

            <Grid.Container gap={2} alignItems="center">
              <Grid>
                <Button
                  loading={isLoading}
                  shadow
                  htmlType="submit"
                  type="success"
                >
                  Submit
                </Button>
              </Grid>
            </Grid.Container>
          </form>
        )}
      </Grid>
    </Grid.Container>
  )
}
